<template>
  <v-dialog v-model="dialog" max-width="500px">
    <template #activator="{ on }">
      <v-btn color="primary" dark class="elevation-0" v-on="on">Создать группу</v-btn>
    </template>

    <v-card :loading="isLoading">
      <v-card-title>Новый элемент</v-card-title>

      <v-card-text>
        <v-container>
          <role-group-form
            :roles="roles"
            @submit="onCreate"
          />
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';
import RoleGroupForm from '@/views/role-groups/components/RoleGroupForm.vue';

export default {
  name: 'new-role-group-dialog',
  components: { RoleGroupForm },
  props: {
    roles: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    dialog: false,
    isLoading: false,
  }),
  methods: {
    ...mapActions(['showNotify']),
    ...mapActions('roleGroups', ['create']),

    async onCreate({ form }) {
      this.isLoading = true;

      try {
        const params = {
          ...form,
        };

        await this.create(params);
        this.showNotify({ message: 'Группа успешно создана' });
        await this.$store.dispatch('roleGroups/getList');
        this.$emit('onCreate');
        this.dialog = false;
      } catch (e) {
        this.showNotify({ type: 'error', mesage: 'При создании произошла ошибка. Обратитесь к администратору' });
      }

      this.isLoading = false;
    },
  },
};
</script>
